<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModal"
    :showModal="showModal"
    @closeModal="showModal = false"
    :idProcesso="idProcesso"
    :tipo="tipoProcesso"
    :protocolo="protocolo"
    :numeroProcesso="numeroProcesso"
  )
  div
    el-table(
      :data='processos',
      v-loading="loading",
      element-loading-text="Carregando...",
      @sort-change="changeOrder"
    )
      template(slot="empty") Não há registros.
      el-table-column(
          width="40",
          v-if="showCheckBox"
        )
          template(slot-scope="scope")
            el-tooltip(
              placement="right",
            )
            el-checkbox(
              :value="vereficaSelecionado(scope.row.id)",
              @change="selecionaItem(scope.row)"
            )
      //- Coluna dedicada para badge Cadastrante Externo (somente MA)
      el-table-column(
        label="",
        width="48",
        align="left",
        header-align="center",
        v-if="isMA"
      )
        template(slot-scope="scope")
          el-tooltip(
            v-if="showContratanteExternoBadge(scope.row)",
            effect="dark",
            content="Cadastrante Externo",
            placement="right",
            :append-to-body="true"
          )
            span(class="el-icon-user-solid" style="color: red")

          el-tooltip(
            v-if="showInteressadoOuConjugeOutroProcessoReurbBadge(scope.row)",
            effect="dark",
            content="Interessado e/ou cônjuge com outro processo REURB",
            placement="right",
            :append-to-body="true"
          )
            span(class="el-icon-warning" style="margin-left: 8px")

      el-table-column(
        label='   ',
        width="30"
      )
        template(slot-scope="scope")
          div
            el-tooltip(
              v-if="getStatusAmbientalOrBloqueio(scope)"
              :content="getRowTooltip(scope)"
              effect='dark',
              placement="top",
              :raw-content="true"
            )
              span
                i(
                  :class="'fa fa-exclamation-triangle ' + getIconStatus(scope)"
                )
      el-table-column(
        prop='numeroProcesso',
        label='Processo',
        width="auto"
      )
      el-table-column(
        v-if="showSetor"
        prop='setor',
        label='Setor',
        :formatter="formatLabelSetor"
        width="auto"
      )
      el-table-column(
        prop='nomeRazaoSocialInteressado',
        :label="isIcmbio ? 'Interessado/Gleba' : 'Nome do interessado'",
        width="auto"
      )
      el-table-column(
        prop='usuario',
        label='Técnico responsável',
        width="auto"
        align='center'
      )
        template(slot-scope="scope")
          span {{ isVerificaTecnico(scope.row) }}
      el-table-column(
        prop='tipo.nome',
        label='Tipo de processo',
        width="auto"
      )
      el-table-column(
        prop='municipioFormatado',
        label='Município(s)',
        width="auto"
      )
      el-table-column(
        v-if="showSituacaoProcesso"
        prop='statusFormatado',
        label='Situação do processo',
        width="auto"
      )
      el-table-column(
        v-if="showVizualizarProcesso"
        label='Ações',
        width='120',
        align='center'
      )
        template(slot-scope='scope')
          el-dropdown(trigger="click")
            el-button(type='primary', size="small")
              | Ações
              i.el-icon-arrow-down.el-icon--right
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item
                .flex(@click="abreModal(scope.row)")
                  i.fa.fa-eye
                  | &nbsp Visualizar processo
  div.pagination
     app-paginacao(
        :total="totalItems"
        :pagina="currentPage",
        @changePage="changePage",
        :tamanhoPagina="pageSize"
      )
</template>

<script>
import EnumFormatter from '@/utils/EnumFormatter'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto.vue'
import AppListagemRelatorio from './AppListagemRelatorio.vue'
import AppPaginacao from '@/components/AppPaginacao'
import setoresMA from '@/utils/ma/setor'
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {

  components: {
    AppListagemRelatorio,
    AppModalVisualizarCompleto,
    AppPaginacao
  },

  data () {
    return {
      idProcesso: 0,
      numeroProcesso: '',
      tipoProcesso: '',
      protocolo: '',
      showModal: false,
      statusAmbiental: {
        STATUS4: '100% Floresta até 2014.',
        STATUS5: 'Art. 73 - V.',
        ALERTA: 'Interseção com área de alerta.'
      },
      isIcmbio: process.env.ESTADO === 'default' || process.env.ESTADO === 'icmbio',
      isMA: process.env.ESTADO === 'ma',
      validacao: false
    }
  },

  props: {
    processos: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      default: 15
    },
    totalItems: {
      type: Number,
      required: true
    },
    loading: {
      Type: Boolean,
      default: false
    },
    currentPage: {
      Type: Number,
      default: 1
    },
    showCheckBox: {
      type: Boolean,
      default: false,
      required: false
    },
    listaIDs: {
      type: Array,
      required: false
    },
    showVizualizarProcesso: {
      type: Boolean,
      default: true,
      required: false
    },
    showSituacaoProcesso: {
      type: Boolean,
      default: true,
      required: false
    },
    showSetor: {
      typeo: Boolean,
      default: true,
      required: false
    }
  },

  methods: {
    changePage (newPage) {
      return this.$emit('changePage', newPage)
    },
    getStatusFormatado (row) {
      return EnumFormatter.getStatusFormatado(row.status, row.setor)
    },
    getCpfCnpjInteressado (row) {
      if (row.cpfCnpjInteressado) {
        return row.cpfCnpjInteressado
      }
      return '-'
    },
    formatLabelSetor (prop, column, row) {
      if (process.env.ESTADO === 'ma') {
        if (row === setoresMA.setores.PROTOCOLO) {
          return setoresMA.nomesSetores.PROTOCOLO
        } else if (row === setoresMA.setores.JURIDICO) {
          return setoresMA.nomesSetores.JURIDICO
        } else if (row === setoresMA.setores.COMISSAO_ILHA) {
          return setoresMA.nomesSetores.COMISSAO_ILHA
        } else if (row === setoresMA.setores.PRESIDENCIA) {
          return setoresMA.nomesSetores.PRESIDENCIA
        } else if (row === setoresMA.setores.DF1) {
          return setoresMA.nomesSetores.DF1
        } else if (row === setoresMA.setores.DF3) {
          return setoresMA.nomesSetores.DF3
        } else if (row === setoresMA.setores.GABINETE) {
          return setoresMA.nomesSetores.GABINETE
        }
      }
      if (prop.perfil === 'TECNICO_DE_CAMPO') {
        return `Técnico de campo`
      }
      if (prop.setor === 'GP' && prop.status.includes('ASSINATURA')) {
        return 'GP - Assinatura'
      }
      if (process.env.ESTADO === 'ap') {
        if (prop.setor === 'EXTERNO' && prop.status === 'AGUARDANDO_CONFIRMACAO_INTERESSADO') {
          return 'CRF'
        }
      }
      return setoresFormatado[row]
    },
    isVerificaMunicipio (prop, column, row) {
      return row && row.length > 0 ? row[0].nome : '-'
    },

    isVerificaTecnico (row) {
      if (row.setor === 'CAF' && !this.isMA) return '-'
      return row?.usuario?.pessoa?.pessoaFisica?.nome || '-'
    },
    abreModal (processo) {
      this.idProcesso = processo.id
      this.numeroProcesso = processo.numeroProcesso
      this.tipoProcesso = processo.tipo.codigo
      this.protocolo = processo.numeroProtocolo
      this.showModal = true
    },
    changeOrder (column) {
      this.$emit('changeOrder', column)
    },
    getStatusAmbientalOrBloqueio (scope) {
      return ['STATUS4', 'STATUS5', 'ALERTA'].includes(scope.row.statusAmbiental) || scope.row.statusBloqueioDinamico === 'BLOQUEADO'
    },
    getIconStatus (scope) {
      if (scope.row.statusBloqueioDinamico === 'BLOQUEADO' && !['STATUS4', 'STATUS5', 'ALERTA'].includes(scope.row.statusAmbiental)) {
        return 'icon-bloqued'
      } else if (scope.row.statusBloqueioDinamico !== 'BLOQUEADO' && ['STATUS4', 'STATUS5', 'ALERTA'].includes(scope.row.statusAmbiental)) {
        return 'icon-status-ambiental'
      }

      return 'icon-metade'
    },

    getRowTooltip (scope) {
      let mensagem = ''

      if (['STATUS4', 'STATUS5', 'ALERTA'].includes(scope.row.statusAmbiental)) {
        mensagem += this.statusAmbiental[scope.row.statusAmbiental]
      }

      if (scope.row.statusBloqueioDinamico === 'BLOQUEADO') {
        mensagem += ` O processo possui interseção com camada de bloqueio.`
      }

      return mensagem
    },

    selecionaItem (processo) {
      this.$emit('selectItem', processo)
    },
    vereficaSelecionado (idProcesso) {
      return this.listaIDs.some(item => item === idProcesso)
    },
    showContratanteExternoBadge (row) {
      return row?.isContratanteExterno && row?.tipo.codigo === 'REURB_INDIVIDUAL'
    },
    showInteressadoOuConjugeOutroProcessoReurbBadge (row) {
      return row?.isInteressadoOuConjugeOutroProcesso && row.isInteressadoOuConjugeOutroProcesso
    }
  }
}
</script>
<style lang="scss" scoped>

  .main {
    padding-top: 10px;
  }
  .pagination {
    text-align: center;
  }
  .align-center {
    text-align: center;
  }

  @media screen and (max-width: 1023px) {
    .hidden-sm {
      display: none;
    }
  }

  .row {
    border-bottom: 1px solid #ebeef5;
    font-weight: bold;
    font-size: 12px;
    span {
      margin-left: 5px;
      font-weight: normal;
    }
  }

>>> .icon-bloqued {
  color: #B22222;
}
>>> .icon-status-ambiental {
  color: #ffda0b;
}

>>> .icon-metade {
  color: #fd831e;
}

.row:first-child {
  border-top: 1px solid #ebeef5;
  margin-top: 30px;
}

>>> .icon-metade {
  color: #fd831e;
}

</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/AppListagemProcessosRelatorio.vue